import {createReducer} from "redux-act";
import {fetchHelpJSONsSuccess} from "modules/actions";
import {IHelpArticle, IHelpCategory, IHelpSection} from "modules/types";

export interface IFetchJSONResponse {
	categories: IHelpCategory;
	sections: IHelpSection;
	articles: IHelpArticle;
}

export interface IHelpsReducer {
	help_content: null | IFetchJSONResponse;
}

const initialState: IHelpsReducer = {
	help_content: null,
};

export const help = createReducer<IHelpsReducer>({}, initialState).on(
	fetchHelpJSONsSuccess,
	(state, payload) => ({
		...state,
		help_content: payload,
	})
);
